class Assets {
  // Base paths to public assets
  private static readonly dashboardBase = "/assets/dark-theme/dashboard";
  private static readonly dashboardLightBase = "/assets/light-theme/dashboard";
  private static readonly filledBase = "/assets/dark-theme/dashboard/filled";
  private static readonly authBase = "/assets/auth";
  private static readonly loginBase = "/assets/login";
  private static readonly ScreenListBaseDark = "/assets/dark-theme/screens";
  private static readonly ScreenListBaseLight = "/assets/light-theme/screens";


  // Normal icons
  static readonly dashboardIcon = `${Assets.dashboardBase}/dashboard.svg`;
  static readonly adminIcon = `${Assets.dashboardBase}/admin.svg`;
  static readonly subscriptionsIcon = `${Assets.dashboardBase}/subscription.svg`;
  static readonly logoutIcon = `${Assets.dashboardBase}/logout.svg`;
  static readonly usersIcon = `${Assets.dashboardBase}/user.svg`;
  static readonly reportsIcon = `${Assets.dashboardBase}/reports.svg`;
  static readonly organisationIcon = `${Assets.dashboardBase}/organization.svg`;
  static readonly gymIcon = `${Assets.dashboardBase}/gym.svg`;
  static readonly staffIcon = `${Assets.dashboardBase}/staff.svg`;
  static readonly workoutIcon = `${Assets.dashboardBase}/workout.svg`;
  static readonly devicesIcon = `${Assets.dashboardBase}/devices.svg`;
  static readonly settingsIcon = `${Assets.dashboardBase}/settings.svg`;
  static readonly userIcon = `${Assets.dashboardBase}/user.svg`;
  static readonly notificationIcon = `${Assets.dashboardBase}/notification.svg`;
  static readonly notificationLightIcon = `${Assets.dashboardLightBase}/notification.svg`;



  // Filled variants
  static readonly dashboardIconFilled = `${Assets.filledBase}/dashboard.svg`;
  static readonly adminIconFilled = `${Assets.filledBase}/admin.svg`;
  static readonly organisationFilled = `${Assets.filledBase}/organization.svg`;
  static readonly subscriptionsIconFilled = `${Assets.filledBase}/subscriptions.svg`;
  static readonly gymIconFilled = `${Assets.filledBase}/gym.svg`;
  static readonly staffIconFilled = `${Assets.dashboardBase}/staff.svg`; // no filled variant provided
  static readonly workoutIconFilled = `${Assets.filledBase}/workout.svg`;
  static readonly devicesIconFilled = `${Assets.filledBase}/devices.svg`;
  static readonly settingsIconFilled = `${Assets.filledBase}/setting-07.svg`;

  // Auth logos and login icons
  static readonly authDarkLogo = `${Assets.authBase}/dark-mode-logo.svg`;
  static readonly authLightLogo = `${Assets.authBase}/light-mode-logo.svg`;
  static readonly darkModeIcon = `${Assets.loginBase}/dark-mode.svg`;
  static readonly loginArrowIcon = `${Assets.loginBase}/login.svg`;

  // screen assets
  static readonly screenAddPlaceholderDark = `${Assets.ScreenListBaseDark}/newScreen.svg`;
  static readonly screenAddPlaceholderLight = `${Assets.ScreenListBaseLight}/newScreen.svg`;
}
export default Assets;
